import formattedDatetime from './helpers/formatted-date-time';

window.addEventListener( 'DOMContentLoaded', () => {
  Array.from( document.getElementsByClassName( 'js-denhaag-calendar' ) )?.forEach( (calendar) => new NLDS_Events_Calendar( calendar ) );
} );

class NLDS_Events_Calendar {
  constructor(el) {
    if (!el) {
      return;
    }

    this.el = el;
    this.id = el.id;
    this.rest_url = window.nlds_plugin_variables?.events?.rest_uri;

    if (!this.rest_url) {
      return;
    }
    this.labels = window.nlds_plugin_variables.pagination;
    this.data = this.el.dataset;

    this.loading = true;

    this.container = this.el.querySelector( '.denhaag-calendar__wrapper' );
    this.pagination = this.el.querySelector( '.denhaag-calendar__pagination' );
    this.paginationGroup = this.pagination.querySelector(
      '.denhaag-pagination__links'
    );
    this.prevArrow = this.pagination.querySelector(
      '.denhaag-pagination__link--arrow[rel="prev"]'
    );
    this.nextArrow = this.pagination.querySelector(
      '.denhaag-pagination__link--arrow[rel="next"]'
    );

    this.totalPages = 1;
    this.data.paged = 1; // Current page.

    this.getEvents();
    this.paginationClickEvents();
  }


  getEvents() {
    // Convert the queryParams object to a query string.
    const queryString = Object.keys( this.data )
      .map( (key) => `${encodeURIComponent( key )}=${encodeURIComponent( this.data[key] )}` )
      .join( '&' );

    fetch( `${this.rest_url}?${queryString}` )
      .then( response => {
        if (!response.ok) {
          throw new Error( 'Network response was not ok' );
        }

        this.totalPages = parseFloat( response.headers.get( 'X-Wp-Totalpages' ) );
        this.pagination.setAttribute( 'data-pages', this.totalPages );

        return response.json();
      } )
      .then( response => {
        this.loading = false;
        this.checkLoader();
        this.loop( response );
      } )
      .finally( () => {
        this.generatePagination( true );
        this.paginationClickEvents();
      } )
      .catch( error => {
        console.error( error );
      } );

  }

  loop(items) {
    this.container.innerHTML = '';
    if( items.length > 0) {
      items?.forEach( item => this.buildCard( {
        id: `event-${item?.ID}-${item?.occurrence}`,
        date_string: item?.date_string,
        excerpt: item?.excerpt,
        post_title: item?.post_title,
        time_string: item?.time_string,
        timestamp: item?.timestamp,
        timestamp_end: item?.timestamp_end,
        url: item?.url,
      } ) );
    } else {
      const message = document.createElement( 'p' );
      message.className = 'denhaag-calendar__message';
      message.innerText = window.nlds_plugin_variables?.events?.no_events_message;
      this.container.appendChild( message );
    }
  }

  /**
   * Format to dateTime attribute.
   * @param {int} timestamp The starting timestamp.
   * @param {int} timestamp_end The ending timestamp.
   * @return {string}
   */
  dateTimeAttribute(timestamp, timestamp_end = timestamp) {
    if (timestamp && timestamp_end) {
      return `${formattedDatetime( timestamp )}/${formattedDatetime( timestamp_end )}`;
    } else if (timestamp && !timestamp_end) {
      return formattedDatetime( timestamp );
    } else if (!timestamp && timestamp_end) {
      return formattedDatetime( timestamp_end );
    }
  }

  buildCard(
    {
      id = 0,
      post_title = '',
      date_string = '',
      time_string = '',
      timestamp = 0,
      timestamp_end = 0,
      url = '',
      excerpt = '',
    }
  ) {
    const cardContainer = document.createElement( 'article' );
    cardContainer.className = 'denhaag-calendar__card';

    if (!!date_string) {
      const header = document.createElement( 'header' );
      header.className = 'denhaag-calendar__card-header';

      const time = document.createElement( 'time' );
      time.innerText = date_string;
      time.setAttribute( 'datetime', this.dateTimeAttribute( timestamp * 1000, timestamp_end * 1000 ) );

      header.appendChild( time );
      cardContainer.appendChild( header );
    }

    const content = document.createElement( 'div' );
    content.className = 'denhaag-calendar__card-content';

    const title = document.createElement( 'h4' );
    title.className = 'denhaag-calendar__card-title';

    const titleAnchor = document.createElement( 'a' );
    titleAnchor.className = 'denhaag-calendar__card-title-anchor';
    titleAnchor.href = url;
    titleAnchor.innerText = post_title;

    title.appendChild( titleAnchor );
    content.appendChild( title );

    if (excerpt) {
      const description = document.createElement( 'p' );
      description.className = 'denhaag-calendar__card-description';
      description.innerText = excerpt;
      content.appendChild( description );
    }

    cardContainer.appendChild( content );

    const footer = document.createElement( 'footer' );
    footer.className = 'denhaag-calendar__card-footer';

    if (!!time_string) {
      const footerTime = document.createElement( 'div' );
      footerTime.className = 'denhaag-calendar__card-footer-time';

      const timeIcon = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      );
      timeIcon.setAttribute( 'width', '1em' );
      timeIcon.setAttribute( 'height', '1em' );
      timeIcon.setAttribute( 'viewBox', '0 0 24 24' );
      timeIcon.setAttribute( 'fill', 'none' );
      timeIcon.setAttribute( 'xmlns', 'http://www.w3.org/2000/svg' );
      timeIcon.classList.add( 'denhaag-icon' );

      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path'
      );
      path.setAttribute(
        'd',
        'M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6C12.5523 6 13 6.44772 13 7V11.5858L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V7C11 6.44772 11.4477 6 12 6Z'
      );
      path.setAttribute( 'fill', 'currentColor' );

      timeIcon.appendChild( path );
      footerTime.appendChild( timeIcon );

      const timeText = document.createElement( 'time' );
      timeText.setAttribute( 'datetime', this.dateTimeAttribute( timestamp * 1000, timestamp_end * 1000 ) );
      timeText.className = 'denhaag-calendar__card-footer-time-text';
      timeText.innerText = time_string;

      footerTime.appendChild( timeText );
      footer.appendChild( footerTime );
    }

    const actionIcon = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );
    actionIcon.setAttribute( 'width', '1em' );
    actionIcon.setAttribute( 'height', '1em' );
    actionIcon.setAttribute( 'viewBox', '0 0 24 24' );
    actionIcon.setAttribute( 'fill', 'none' );
    actionIcon.setAttribute( 'xmlns', 'http://www.w3.org/2000/svg' );
    actionIcon.classList.add( 'denhaag-icon' );

    const actionPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    actionPath.setAttribute(
      'd',
      'M12.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L16.586 13H5a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
    );
    actionPath.setAttribute( 'fill', 'currentColor' );

    actionIcon.appendChild( actionPath );
    footer.appendChild( actionIcon );

    cardContainer.appendChild( footer );

    this.container.appendChild( cardContainer );
  }


  checkLoader() {
    if (!this.loading) {
      this.el.classList.remove( 'denhaag-calendar--loading' );
      this.removeLoader();
    } else {
      this.el.classList.add( 'denhaag-calendar--loading' );
      this.addLoader();
    }
  }

  addLoader() {
    const loaderElement = document.createElement( 'div' );
    loaderElement.className = 'denhaag-calendar__loader';
    this.container.appendChild( loaderElement );
  }

  removeLoader() {
    const loader = this.container.querySelector( '.denhaag-calendar__loader' );
    if (!!loader) {
      this.container.removeChild( loader );
    }
  }

  /**
   * Generate the pagination, using the `createPaginationButton()` method.
   *
   * @param bool removeOld, Remove earlier generated pagination.
   */
  generatePagination(removeOld = false) {
    if (1 >= this.totalPages) {
      this.pagination.remove();
      return;
    }

    if (removeOld && !!this.paginationGroup) {
      this.paginationGroup.innerHTML = '';
    }

    let pagination = [];
    if (4 >= this.totalPages) {
      // Check on 4 instead of 5 due to duplicate ... appearing, which looks silly :)
      // Create array of max pages length.
      pagination = Array( this.totalPages )
        .fill( null )
        .map( (_, i) => i + 1 )
        .filter( (i) => i >= 1 && i <= this.totalPages );
    } else {
      // First and last item must always be available.
      pagination = [
        ...new Set( [
          parseFloat( this.data.paged ) - 2,
          parseFloat( this.data.paged ) - 1,
          parseFloat( this.data.paged ),
          parseFloat( this.data.paged ) + 1,
          parseFloat( this.data.paged ) + 2,
        ] ),
      ]
        // Remove all negatives and those above the max-pages.
        .filter( (i) => i >= 1 && i <= this.totalPages )
        // Sort 1 to 10.
        .sort( (a, b) => a - b );

      // Prepend first page.
      if (-1 === pagination.indexOf( 1 )) {
        pagination.unshift( 1 );
      }

      // Prepend max page.
      if (-1 === pagination.indexOf( this.totalPages )) {
        pagination.push( this.totalPages );
      }

      // Remove duplicates.
      pagination = [...new Set( pagination )];
    }

    pagination?.forEach( (i) => this.createPaginationButton( i ) );
  }

  /**
   * Create pagination button.
   *
   * @param {number} page Number of the page.
   */
  createPaginationButton(page) {
    if (!page || page > this.totalPages) {
      return;
    }

    const btn = document.createElement( 'BUTTON' );
    const li = document.createElement( 'LI' );

    btn.classList.add( 'denhaag-pagination__link' );
    btn.setAttribute( 'data-page', page );
    btn.setAttribute( 'aria-label', `${this.labels.page}: ${page}` );
    btn.innerHTML = page;

    // Set previous item attributes.
    if (page === parseFloat( this.data.paged ) - 1) {
      btn.setAttribute( 'rel', 'prev' );
    }

    // Set next item attributes.
    if (page === parseFloat( this.data.paged ) + 1) {
      btn.setAttribute( 'rel', 'next' );
    }

    // Set current item attributes.
    if (page === parseFloat( this.data.paged )) {
      li.setAttribute( 'aria-current', 'page' );
      btn.classList.add( 'denhaag-pagination__link--current' );
    }

    if (
      1 !== page &&
      this.totalPages !== page &&
      Math.abs( page - parseFloat( parseFloat( this.data.paged ) ) ) > 1
    ) {
      const span = document.createElement( 'SPAN' );
      span.innerHTML = '...';
      span.classList.add( 'denhaag-pagination__dots' );
      span.setAttribute( 'aria-hidden', 'true' );
      li.appendChild( span );
    } else {
      li.appendChild( btn );
    }
    this.paginationGroup.appendChild( li );
  }

  /**
   * Fire events on pagination mouse-click.
   * Will be initialized on each re-render after the ajax call.
   */
  paginationClickEvents() {
    [...this.paginationGroup.querySelectorAll( '[data-page]' )]?.forEach(
      btn =>
        (btn.onclick = () => {
          const page = parseFloat( btn?.dataset?.page || 1 );

          if (page > parseFloat( this.data.paged ) && 1 < page) {
            this.enableOrDisable( this.nextArrow, true );
            this.enableOrDisable( this.prevArrow, true );
          }

          if (page < parseFloat( this.data.paged ) || 1 > page) {
            this.enableOrDisable( this.nextArrow, true );
            this.enableOrDisable( this.prevArrow, true );
          }

          if (page === parseFloat( this.totalPages )) {
            this.enableOrDisable( this.nextArrow, false );
          }

          if (page === 1) {
            this.enableOrDisable( this.prevArrow, false );
          }

          // Update page.
          this.data.paged = page;
          this.getEvents();
        })
    );
  }

  /**
   * Enable or disable element.
   *
   * @param {HTMLElement} element
   * @param {boolean}     enable
   */
  enableOrDisable(element, enable = true) {
    if (!!enable) {
      element.disabled = false;
      element.setAttribute( 'tabindex', 0 );
      if (
        element.classList.contains(
          'denhaag-pagination__link--disabled'
        )
      ) {
        element.classList.remove(
          'denhaag-pagination__link--disabled'
        );
      }
    } else {
      element.disabled = true;
      element.setAttribute( 'tabindex', '-1' );
      if (
        element.classList.contains(
          'denhaag-pagination__link--disabled'
        )
      ) {
        element.classList.add( 'denhaag-pagination__link--disabled' );
      }
    }
  }
}

